import { useCallback, useMemo } from 'react'
import { IMoreMenuItem, useIsUnmounted } from '@sales-center/components'
import { useActivitiesContext } from '../../../../context'
import { changeContentActionCreator } from '../../../../state'
import { deleteActivityEffect } from '../../../../effects'
import { useAppDispatch } from '@user/store/hooks'
import { fetchOverdueActivitiesCount } from '@user/features/Activity/store'
import { useSelector } from 'react-redux'
import { selectCurrentUser } from '@user/store/authorization'
import { useRefreshActivityHistory } from '@user/features/Activity'
import type { ENTITY_TYPES } from '@sales-center/common'

type Props = {
  entityId: number
  entityType: ENTITY_TYPES
}

export function useMoreOptions(props: Props) {
  const { entityId, entityType } = props
  const [{ current }, dispatch] = useActivitiesContext()
  const isUnmounted = useIsUnmounted()
  const appDispatch = useAppDispatch()
  const { userId } = useSelector(selectCurrentUser)
  const { refreshHistory } = useRefreshActivityHistory(
    Array.isArray(entityId) ? entityId[0] : entityId,
    entityType,
  )

  const onEditClick = useCallback(() => {
    dispatch(changeContentActionCreator('form'))
  }, [dispatch])

  const onDeleteClick = useCallback(async () => {
    const action = await deleteActivityEffect(current || -1)
    refreshHistory()
    await appDispatch(fetchOverdueActivitiesCount(userId))
    if (isUnmounted()) return

    dispatch(action)
  }, [current, refreshHistory, appDispatch, userId, isUnmounted, dispatch])

  return useMemo<IMoreMenuItem[]>(
    () => [
      {
        label: 'Edit',
        onClick: onEditClick,
        dataTestId: `activity-more-item-edit-button-${current}`,
      },
      {
        label: 'Delete',
        onClick: onDeleteClick,
        dataTestId: `activity-more-item-delete-button-${current}`,
      },
    ],
    [onEditClick, current, onDeleteClick],
  )
}
